import React, { useEffect, useState } from 'react';
import { HiOutlineTrash, HiOutlineExternalLink } from 'react-icons/hi';
import { useAuth } from "../context/AuthProvider";
import { useNavigate } from 'react-router-dom';
import config from '../config';

const Historique = () => {
    const { login, user } = useAuth();
    const [productionData, setProductionData] = useState(null); // Initialize as null

    useEffect(() => {
        // fetch(`http://localhost:3080/productions?user=${user.id}`)
        // fetch(`http://themis.msh-lse.fr:3080/productions?user=${user.id}`)
        fetch(`${config.BASE_URL}/productions?user=${user.id}`)
          .then(response => response.json())
          .then(data => {
            setProductionData(data);
          })
          .catch(error => console.error('Error:', error));
    }, []);

    const handleDelete = (id) => {
        // fetch(`http://localhost:3080/productions?id=${id}&user=${user.id}`, {
        // fetch(`http://themis.msh-lse.fr:3080/productions?id=${id}&user=${user.id}`, {
        fetch(`${config.BASE_URL}/productions?id=${id}&user=${user.id}`, {
          method: 'DELETE',
        })
        .then(response => response.json())
        .then(data => {
            setProductionData(productionData =>
                productionData.filter(production => production.id !== id)
            );
          })
        .catch(error => console.error('Error:', error));
      };

    const navigate = useNavigate();

    const handleExternalLinkClick = (analysisId, textData, usageData, errorData) => {
    navigate('/analyse', { state: { id: analysisId, text: textData, usage: usageData, error: errorData} });
    };

    if (productionData === null) {
        return <div>Chargement en cours...</div>;
    }

    return (
        <div className="mx-8">
            <h1 className="py-4 text-xl font-bold leading-tight tracking-tight text-gray-900">Historique</h1>
            <div className="overflow-hidden mx-auto max-w-4xl shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                <table className="table-auto min-w-full divide-y divide-gray-300">
                    <thead>
                        <tr className="bg-gray-100 cursor-pointer">
                            <th className="px-3 py-3.5 text-left text-md font-semibold text-gray-900 max-w-[300px]"></th>
                            <th className="px-3 py-3.5 text-left text-md font-semibold text-gray-900 max-w-[300px]"></th>
                            <th className="px-3 py-3.5 text-left text-md font-semibold text-gray-900 max-w-[300px]">Texte d'entrée</th>
                            <th className="px-3 py-3.5 text-left text-md font-semibold text-gray-900 max-w-[300px]">Date</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                        {productionData.map((item, index) => (
                            <tr key={index}>
                                <td className="whitespace-nowrap px-3 py-4 text-md text-gray-500 max-w-[300px]"><HiOutlineTrash className="cursor-pointer" onClick={() => handleDelete(item.id)}/></td>
                                <td className="whitespace-nowrap px-3 py-4 text-md text-gray-500 max-w-[300px]"><HiOutlineExternalLink className="cursor-pointer" onClick={() => handleExternalLinkClick(item.id, item.original, item.analyzed, item.error_analyzed)}/></td>
                                <td className="whitespace-nowrap px-3 py-4 text-md text-gray-500 max-w-[300px] overflow-x-auto">{item.original}</td>
                                <td className="whitespace-nowrap px-3 py-4 text-md text-gray-500 max-w-[300px] overflow-x-auto">
                                {new Date(item.created_at).getUTCDate()}-{new Date(item.created_at).getUTCMonth() + 1}-{new Date(item.created_at).getUTCFullYear()}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Historique;
